import type { IconSvgObject } from './types';

const MapPinXInsideIcon: IconSvgObject = [
  ["path", { d: "M12 2C7.58172 2 4 5.61783 4 10.0807C4 12.6325 5 14.6167 7 16.389C8.40971 17.6382 10.9746 20.3179 12 21.9999C13.0773 20.3514 15.5903 17.6382 17 16.389C19 14.6167 20 12.6325 20 10.0807C20 5.61783 16.4183 2 12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 7.5L12.0083 9.99583M12.0083 9.99583L9.50832 12.5M12.0083 9.99583L14.5083 12.5M12.0083 9.99583L9.51664 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MapPinXInsideIcon;
